module.exports = __webpack_public_path__ + "static/full09-25760b77a08af7b91e3bd641abcd12da.png";